/**
 * Copyright IBM Corp. 2024
 *
 * This source code is licensed under the Apache-2.0 license found in the
 * LICENSE file in the root directory of this source tree.
 */

/**
 * @license
 *
 * Copyright IBM Corp. 2025
 *
 * This source code is licensed under the Apache-2.0 license found in the
 * LICENSE file in the root directory of this source tree.
 */
/**
 * How to lay out radio buttons.
 */
var CHECKBOX_ORIENTATION;
(function (CHECKBOX_ORIENTATION) {
    /**
     * Laying out radio buttons horizontally.
     */
    CHECKBOX_ORIENTATION["HORIZONTAL"] = "horizontal";
    /**
     * Laying out radio buttons vertically.
     */
    CHECKBOX_ORIENTATION["VERTICAL"] = "vertical";
})(CHECKBOX_ORIENTATION || (CHECKBOX_ORIENTATION = {}));

export { CHECKBOX_ORIENTATION };
//# sourceMappingURL=defs.js.map
